<mat-card class="mb-3 mb-md-2 izy-sharp-bl col-md-12 d-flex flex-column h-100 custom-card">
  <mat-card-header>
    <!-- Titolo e sottotitolo insieme in un wrapper: mat-card-header proietta
         mat-card-title/subtitle in una sua riga flex, quindi un h5 "nudo"
         finirebbe accanto al sottotitolo invece che sopra. -->
    <div class="me-auto">
      <h5 class="mb-1">Resoconto per trimestre</h5>
      <mat-card-subtitle>Anno selezionato ({{selectedYear}})</mat-card-subtitle>
    </div>
  </mat-card-header>

  <mat-card-content class="mt-2">
    <div *ngIf="isLoading" class="spinner-container">
      <mat-spinner diameter="50"></mat-spinner>
    </div>

    <div *ngIf="errorMessage" class="error-message">
      {{ errorMessage }}
    </div>

    <!-- Fallimento di una sola sorgente: il grafico resta visibile, con avviso. -->
    <div *ngIf="!isLoading && !errorMessage && warningMessage" class="warning-message">
      {{ warningMessage }}
    </div>

    <div *ngIf="!isLoading && !errorMessage" style="height: 400px">
      <canvas
        baseChart
        [data]="barChartData"
        [options]="barChartOptions"
        [type]="barChartType"
        [plugins]="barChartPlugins"
      >
      </canvas>
    </div>
  </mat-card-content>

  <mat-card-actions class="d-flex justify-content-end">
    <button mat-raised-button color="primary" class="custom-button-border" (click)="refreshData()">
      Ricarica dati
      <mat-icon>refresh</mat-icon>
    </button>
  </mat-card-actions>

</mat-card>
